/**
 * Certmgr — widget-first (2.1).
 * Panels: pages/modules/certmgr/panels.tsx
 */
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('certmgr');

export default function CertmgrPage() {
  return <ModuleWorkspace def={DEF} hideHeader defaultTab='overview' />;
}
